import { useContext, useEffect, useReducer } from 'react';
import { Switch, Route } from 'react-router-dom';
import styled from 'styled-components';
import { SELFREGISTRATION_ROUTE_ALIASES } from '../utils/redirectUtils';
import useSelfRegistrationLanguage from '../hooks/useSelfRegistrationLanguage';
import ThemeContext from '../contexts/ThemeContext';
import withHeader from '../hocs/withHeader';
import { FullBackgroundImageContainer } from '../components/basicComponents';
import background from '../images/background.png';
import { EmailVerificationPage, PhoneVerificationPage } from '../components/ContactInfoStep';
import { ConfirmEmailStep, ConfirmPhoneStep} from '../components/ConfirmEmailStep';
import SelectCostCenterStep from '../components/SelectCostCenterStep';
import SetPasswordStep from '../components/SetPasswordStep';
import FinalStep from '../components/FinalStep';

const StyledWrapper = styled.div`
  display: flex;
  height: 80%;
  flex: 1;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  overflow-y: auto;
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0px 8px 16px 8px rgba(21, 21, 41, 0.25);
  max-width: 600px;
  min-width: 288px;
  & > div {
    flex: 1;
    display: flex;
    width: 100%;
    & > div {
      flex: 1;
      display: flex;
      justify-content: 'flex-start';
    }
  }
`;

const ImageContainer = styled(FullBackgroundImageContainer)`
  flex: 1;
  padding: 21px;
  justify-content: center;
  align-items: center;
  ${({ solidBackground }) => solidBackground && `background: ${solidBackground};`}
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const SelfRegistrationWizard = () => {
  const { colors } = useContext(ThemeContext);
  const [ignored, forceUpdate] = useReducer(x => x + 1, 0); // eslint-disable-line no-unused-vars
  useSelfRegistrationLanguage();
  useEffect(() => {
    const func = async () => {
      forceUpdate();
    };
    document.addEventListener('changeLang', func);
    return () => {
      document.removeEventListener('changeLang', func);
    };
  }, []);

  return (
      <ImageContainer
        blendMode='transparent'
        backgroundImage={background}
        solidBackground={colors.selfRegistrationBackground}
      >
        <StyledWrapper>
          <Switch>
            <Route exact path={SELFREGISTRATION_ROUTE_ALIASES.email} component={EmailVerificationPage}/>
            <Route exact path={SELFREGISTRATION_ROUTE_ALIASES.check_email} component={ConfirmEmailStep}/>
            <Route path={SELFREGISTRATION_ROUTE_ALIASES.phone} component={PhoneVerificationPage}/>
            <Route exact path={SELFREGISTRATION_ROUTE_ALIASES.check_phone} component={ConfirmPhoneStep}/>
            <Route path={SELFREGISTRATION_ROUTE_ALIASES.cost_center} component={SelectCostCenterStep}/>
            <Route path={SELFREGISTRATION_ROUTE_ALIASES.password} component={SetPasswordStep}/>
            <Route path={SELFREGISTRATION_ROUTE_ALIASES.auth_complete} component={FinalStep}/>
          </Switch>
        </StyledWrapper>
      </ImageContainer>
  );
};

export default withHeader(SelfRegistrationWizard);
